import { makeEnvironmentProviders } from '@angular/core';
import { PackageRepository } from '../../@core/repositories/package.repository';
import { PromoRepository } from '../../@core/repositories/promo.repository';
import { provideHeaderService } from '../repository/header/header.adapter';
import { OtpRepository } from '../../@core/repositories/otp.repository';
import { CheckoutRepository } from '@data/repositories/checkout.repository';
import { PromoAdapter } from '../repository/promo/promo.adapter';
import { PackageAdapter } from '../repository/package/package.adapter';
import { CheckoutAdapter } from '../repository/checkout/checkout.adapter';
import { OtpAdapter } from '../repository/otp/otp.adapter';
import { RoamingRepository } from '@data/repositories/roaming.repository';
import { RoamingAdapter } from '../repository/roaming/roaming.adapter';
import { WorldCupRepository } from '@data/repositories/world-cup.repository';
import { WorlCupAdapter } from '../repository/world-cup/world-cup.adapter';
import { RenewalPackageRepository } from '@data/repositories/renewal-package.repository';
import { RenewalPackageImplementation } from '../repository/renewal-package/renewal-package.implementation';
import { PaymentRepository } from '@data/repositories/payment.repository';
import { PaymentAdapter } from '../repository/payment/payment.adapter';

export const repositoryProviders = () => {
    return makeEnvironmentProviders([
        { provide: PromoRepository, useClass: PromoAdapter },
        { provide: PackageRepository, useClass: PackageAdapter },
        { provide: OtpRepository, useClass: OtpAdapter },
        { provide: RoamingRepository, useClass: RoamingAdapter },
        { provide: WorldCupRepository, useClass: WorlCupAdapter },
        { provide: RenewalPackageRepository, useClass: RenewalPackageImplementation },
        { provide: CheckoutRepository, useClass: CheckoutAdapter },
        { provide: PaymentRepository, useClass: PaymentAdapter },
        provideHeaderService()
    ]);
};
